import { useFormikContext } from "formik";
import { useEffect } from "react";

const FormObserver = ({ onFormDirty }) => {
  const { dirty } = useFormikContext();

  useEffect(() => {
    onFormDirty(dirty); // Notify parent about form state
  }, [dirty, onFormDirty]);

  return null;
};

export default FormObserver